<script lang="ts">
  import StatusTag from "@kontextwerk/web-sdk/ui/display/StatusTag.svelte"
  import type { ContactTagPresentation } from "../../_logic/contact-quality-tags"
  import { RICH_TOOLTIP_CLASS } from "../../../../../_shared/_logic/rich-tooltips"

  type Props = {
    tags?: ContactTagPresentation[]
    emptyLabel?: string
    maxLabelLength?: number | null
    emptyTextColor?: string
    stacked?: boolean
    splitRoleAndName?: boolean
    prefixRoleSubLabel?: boolean
  }

  let {
    tags = [],
    emptyLabel = "–",
    maxLabelLength = 25,
    emptyTextColor = "color-mix(in srgb, var(--text-invers-100) 72%, transparent)",
    stacked = false,
    splitRoleAndName = false,
    prefixRoleSubLabel = false,
  }: Props = $props()

  const truncateLabel = (value: string | null | undefined) => {
    const normalized = String(value ?? "").trim()

    if (maxLabelLength === null) return normalized

    if (normalized.length <= maxLabelLength) return normalized

    return `${normalized.slice(0, Math.max(0, maxLabelLength - 3)).trimEnd()}...`
  }
</script>

<span class:stacked class="work-order-contact-tags">
  {#if tags.length}
    {#each tags as tag, idx (`${tag.id}-${idx}`)}
      <StatusTag
        variant="neutral"
        size="sm"
        label={splitRoleAndName && tag.nameLabel
          ? truncateLabel(tag.nameLabel)
          : truncateLabel(tag.label)}
        subLabel={tag.subLabel ??
          (splitRoleAndName && tag.roleLabel
            ? prefixRoleSubLabel
              ? `Rolle: ${tag.roleLabel}`
              : tag.roleLabel
            : undefined)}
        icon={tag.icon}
        color={tag.color}
        tooltipContent={tag.tooltip}
        tooltipHtml={tag.tooltipHtml ?? false}
        tooltipClassName={tag.tooltipHtml ? RICH_TOOLTIP_CLASS : ""}
      />
    {/each}
  {:else}
    <span
      class="work-order-contact-tags__empty"
      style={`--contact-empty-color: ${emptyTextColor};`}
    >
      {emptyLabel}
    </span>
  {/if}
</span>

<style lang="less">
  .work-order-contact-tags {
    display: inline-flex;
    flex-wrap: wrap;
    gap: 0.3rem;
    align-items: flex-start;
  }

  .work-order-contact-tags.stacked {
    flex-direction: column;
    flex-wrap: nowrap;
    gap: 0.25rem;
  }

  .work-order-contact-tags__empty {
    color: var(--contact-empty-color);
    font-weight: 700;
  }
</style>
